export default __webpack_public_path__ + "static/media/ASSETS-04.b622740a.png";